<template>
  <v-card class="mb-3">
    <v-card-title
      v-if="typeof noticeObj.title !== 'undefined' && noticeObj.title !== ''"
      class="pt-2 pb-2 font-weight-bold subtitle-2">
      <v-icon v-if="noticeObj.homework === 1">fa-pencil-alt</v-icon>
      <v-icon v-else>message</v-icon>
      &nbsp;
      <span v-if="noticeObj.homework === 1">Homework:&nbsp;</span>
      <span>{{ noticeObj.title }}</span>
    </v-card-title>

    <v-card-title
      v-if="typeof noticeObj.event_title !== 'undefined' && noticeObj.event_title !== ''"
      class="pt-2 pb-2 font-weight-bold subtitle-2">
      <span>{{ noticeObj.event_title }}</span>
    </v-card-title>

    <v-divider/>
    <v-card-text
      style="overflow-wrap: break-word; overflow: scroll;"
      v-html="noticeObj.contents"/>

    <v-card-text v-if="typeof noticeObj.files !== 'undefined' && noticeObj.files.length > 0">
      <div
        v-if="imageFiles.length > 0"
        class="mb-3">
        <div class="mb-2 font-weight-medium">Images:</div>
        <div
          v-for="file in imageFiles"
          :key="file.id"
          class="mb-2">
          <div class="d-flex align-center mb-1">
            <span class="caption">{{ file.filename }}</span>
            <v-spacer/>
            <v-btn
              small
              outlined
              color="primary"
              @click="downloadFile(file)"
              class="ml-2">
              <v-icon
                small
                left>mdi-download</v-icon>
              Download
            </v-btn>
          </div>
          <div
            v-if="loadingDocuments[file.id]"
            class="text-center py-4">
            <v-progress-circular
              indeterminate
              color="primary"/>
            <div class="caption mt-2">Loading image...</div>
          </div>
          <div
            v-else-if="documentErrors[file.id]"
            class="error--text caption">
            {{ documentErrors[file.id] }}
            <v-btn
              small
              text
              color="primary"
              @click="fetchDocument(file)">
              Retry
            </v-btn>
          </div>
          <div
            v-else-if="documentBlobs[file.id]"
            class="text-center">
            <img
              :src="documentBlobs[file.id]"
              :alt="file.filename"
              style="max-width: 100%; max-height: 400px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"
              @error="onImageError(file.id)">
          </div>
          <div
            v-else
            class="text-center py-2">
            <v-btn
              small
              outlined
              @click="fetchDocument(file)">
              <v-icon
                small
                left>mdi-image</v-icon>
              Load Image
            </v-btn>
          </div>
        </div>
      </div>

      <div v-if="nonImageFiles.length > 0">
        <div class="mb-2 font-weight-medium">Attached Files:</div>
        <div
          v-for="file in nonImageFiles"
          :key="file.id"
          class="mb-1">
          <div class="d-flex align-center">
            <v-icon
              small
              class="mr-2">
              {{ getFileIcon(file.filename) }}
            </v-icon>
            <a
              :href="file.href"
              target="_blank"
              rel="noopener"
              style="text-decoration: none; flex: 1;"
              class="primary--text">
              {{ file.filename }}
            </a>
            <v-btn
              small
              outlined
              color="primary"
              @click="downloadFile(file)"
              class="ml-2">
              <v-icon small>mdi-download</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </v-card-text>

    <v-card-text v-if="noticeObj.homework === 1">Homework Due Date: {{ noticeObj.homework_due_date }}</v-card-text>

    <!-- for event -->
    <v-card-title
      v-if="typeof noticeObj.event_title !== 'undefined' && noticeObj.event_title !== ''">
      <v-card-text v-if="noticeObj.location !== 'undefined' && noticeObj.location !=='' ">
        <v-icon v-if="noticeObj.location !== 'undefined' && noticeObj.location !== ''">fas fa-map-marker-alt</v-icon>
        &nbsp;
        <span><b>Location:</b> {{ noticeObj.location }}</span>
      </v-card-text>

      <v-card-text v-if="noticeObj.event_time !== 'undefined' && noticeObj.event_time !=='' ">
        <v-icon v-if="noticeObj.event_time !== 'undefined' && noticeObj.event_time !== ''">far fa-clock</v-icon>
        &nbsp;
        <span><b>Time:</b> {{ noticeObj.event_time }}</span>
      </v-card-text>
    </v-card-title>

    <v-divider/>
    <v-card-actions class="caption pt-1 pb-1 pl-3 pr-2">
      <span v-if="noticeObj.teacher !== ''">Posted by {{ noticeObj.teacher }}<br>{{ noticeObj.date }}</span>
      <v-spacer/>
      <v-btn
        depressed
        small
        :color="colourTag"
        :ripple="false"
        class="black--text"
        style="font-size: 10px; min-width:0px"
        v-if="tag !== ''">{{ tag }}</v-btn>
      <v-btn
        icon
        @click="toggleFavourite(noticeObj.id)">
        <v-icon
          color="yellow"
          v-if="favourite == 1">star</v-icon>
        <v-icon
          v-else>star_border</v-icon>
      </v-btn>
      <v-btn
        icon
        :href="getEmailURI"
        v-if="!disableReplyButton">
        <v-icon>reply</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    noticeObj: {
      type: Object,
      default: () => { return {} }
    }
  },

  data: function () {
    return {
      favourite: this.noticeObj.fav,
      documentBlobs: {},
      loadingDocuments: {},
      documentErrors: {}
    }
  },

  computed: {
    getEmailURI: function () {
      var encodedText = encodeURIComponent('Reply to @school teacher message: ' + this.noticeObj.title)
      return 'mailto:' + this.noticeObj.teacher_email + '?subject=' + encodedText
    },
    tag: function () {
      if (parseInt(this.noticeObj.tag_important) === 1) {
        return 'IMPORTANT'
      } else if (parseInt(this.noticeObj.tag_event) === 1) {
        return 'EVENT'
      } else if (parseInt(this.noticeObj.tag_achievement) === 1) {
        return 'ACHIEVEMENT'
      } else if (this.noticeObj.type === 'msg') {
        return ''
      }
      return 'COMMON'
    },
    colourTag: function () {
      if (parseInt(this.noticeObj.tag_important) === 1) {
        return 'red'
      } else if (parseInt(this.noticeObj.tag_event) === 1) {
        return 'yellow darken-3'
      } else if (parseInt(this.noticeObj.tag_achievement) === 1) {
        return 'deep-purple lighten-1'
      } else if (this.noticeObj.type === 'msg') {
        return ''
      }
      return '#fb8c00'
    },
    disableReplyButton: function () {
      if (typeof this.noticeObj.disableReplyButton !== 'undefined') {
        return this.noticeObj.disableReplyButton
      } else {
        return true
      }
    },
    imageFiles: function () {
      if (!this.noticeObj.files) return []
      return this.noticeObj.files.filter(file => this.isImageFile(file.filename))
    },
    nonImageFiles: function () {
      if (!this.noticeObj.files) return []
      return this.noticeObj.files.filter(file => !this.isImageFile(file.filename))
    }
  },

  mounted () {
    this.imageFiles.forEach(file => {
      this.fetchDocument(file)
    })
  },

  methods: {
    toggleFavourite: function (id) {
      var postOrDelete = (this.favourite === 0) ? 'post' : 'delete'
      var url = 'caregiversV2/' + this.$store.state.Dbasename + '/' + this.$store.state.userId +
      '/favouritesV2/' + id
      var data = {
        type: this.noticeObj.type
      }

      if (postOrDelete === 'post') {
        this.$http.post(url, data)
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$http.delete(url, { data: data })
          .catch(function (error) {
            console.log(error)
          })
      }
      this.favourite = !this.favourite
      return this.favourite
    },

    isImageFile: function (filename) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      const extension = filename.split('.').pop().toLowerCase()
      return imageExtensions.includes(extension)
    },

    getFileIcon: function (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      switch (extension) {
        case 'pdf':
          return 'mdi-file-pdf-box'
        case 'doc':
        case 'docx':
          return 'mdi-file-word'
        case 'xls':
        case 'xlsx':
          return 'mdi-file-excel'
        case 'ppt':
        case 'pptx':
          return 'mdi-file-powerpoint'
        case 'txt':
          return 'mdi-file-document'
        case 'zip':
        case 'rar':
          return 'mdi-file-zip'
        default:
          return 'mdi-file'
      }
    },

    fetchDocument: function (document) {
      const id = document.id || document.filename
      this.$set(this.loadingDocuments, id, true)

      if (this.documentErrors[id]) {
        this.$delete(this.documentErrors, id)
      }

      const targetUrl = document.href

      fetch(targetUrl, {
        method: 'GET',
        headers: {
          'Accept': '*/*'
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok: ' + response.status)
          }
          return response.blob()
        })
        .then(blob => {
          const blobUrl = URL.createObjectURL(blob)
          this.$set(this.documentBlobs, id, blobUrl)
        })
        .catch(error => {
          console.error('Error fetching document:', error)
          this.$set(this.documentErrors, id, 'Failed to load the document. ')
        })
        .finally(() => {
          this.$set(this.loadingDocuments, id, false)
        })
    },

    downloadFile: function (file) {
      const link = document.createElement('a')
      if (this.documentBlobs[file.id]) {
        link.href = this.documentBlobs[file.id]
      } else {
        link.href = file.href
      }
      link.download = file.filename
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    onImageError: function (fileId) {
      this.$set(this.documentErrors, fileId, 'Failed to load image.')
    }
  },

  beforeDestroy () {
    Object.values(this.documentBlobs).forEach(blobUrl => {
      URL.revokeObjectURL(blobUrl)
    })
  }
}
</script>
